import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Usuario } from '../models/usuario.model';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService {
  http = inject(HttpClient);
  auth = inject(AuthService);

  private createAuthorizationHeader(): HttpHeaders {
    const token = this.auth.getToken();
    const headers: Record<string, string> = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
    if (token !== null && token !== undefined && token !== 'null') {
      headers['Token'] = token;
    }
    return new HttpHeaders(headers);
  }

  post(url: string, data: any): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(url, data, { headers: this.createAuthorizationHeader() })
        .pipe(map(this.extractData), catchError(this.handleError))
        .subscribe((data) => {
          if (data && (data.codigo === 202 || data.codigo_respuesta === 202)) {
            this.auth.handleInvalidSession();
            observer.error(data);
            observer.complete();
            return;
          }

          observer.next(data);
          observer.complete();
        });
    });
  }

  get(url: string): Observable<any> {
    return new Observable((observer) => {
      this.http
        .get(url, { headers: this.createAuthorizationHeader() })
        .pipe(map(this.extractData), catchError(this.handleError))
        .subscribe((data) => {
          if (data && (data.codigo === 202 || data.codigo_respuesta === 202)) {
            this.auth.handleInvalidSession();
            observer.error(data);
            observer.complete();
            return;
          }

          observer.next(data);
          observer.complete();
        });
    });
	}

  extractData(res: Response | any) {
    //if (!environment.production) console.log(res.url, res.status, res);
    return res || {};
  }

  handleError(error: Response | any): any {
    if (!environment.production) console.log(error);
    return throwError(() => JSON.parse(error._body) || error);
  }

  getUser(): Usuario {
		let user = new Usuario();
		if (localStorage.getItem('Session')) {
			user = JSON.parse(localStorage.getItem('Session')!).user;
		}
		return user;
	}
}
